import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import * as React from "react";

const styles = createStyles({
    root: {
        flexGrow: 1
    }
})

export type ReportToolbarSpacerProps = WithStyles<typeof styles>

const ReportToolbarSpacer = (props: ReportToolbarSpacerProps) => (<div className={props.classes.root}></div>)

export default withStyles(styles)(ReportToolbarSpacer)